export default __webpack_public_path__ + "static/media/8.5b8deacd.jpg";